import React, { useCallback, useEffect, useRef, useState } from "react";
import { useRecoilValue } from "recoil";
import { userState } from "../Services/RecoilAtoms";
import Swal from "sweetalert2";
import {
  AdminCreateProducts,
  ViewAdminBrands,
  getCategories,
} from "../utils/Api/ApiCalls";
import { ImageCropper } from "../components/imagecropper";
import { useParams } from "react-router-dom";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


const AddProducts = () => {
  const params = useParams();
  const currentUser = useRecoilValue(userState);
  const [brandData, setBrandData] = useState([]);
  const [categories, setCategories] = useState({});
  const [data, setData] = useState({
    categoryName: "",
    description: "",
  });
  const [categoryData, setCategoryData] = useState({
    categories: [],
    subCategories: [],
    brands: [],
  });
  const [brands, setBrands] = useState([]);
  const [subcategories, setSubCategories] = useState([]);
  const [load, setLoad] = useState(false);
  const quillRef = useRef();

  const [formData, setFormData] = useState({
    productTitle: "",
    fullDesc: "",
    regularPrice: "",
    promotionalPrice: "",
    currency: "",
    category: "",
    subcategory: "",
    brand: "",
    images: null,
    // attributes: {},
  });
  // const [attributes, setAttributes] = useState({});
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
  ];

  const ViewAllBrands = async () => {
    try {
      const response = await ViewAdminBrands(
        currentUser.data.info.id,
        currentUser.data.token
      );
      setBrandData(response.data);
    } catch (err) {
    Swal.fire({ icon: "error", title: "Error", html: err?.response?.data?.html || err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };
  useEffect(() => {
    //ViewAllBrands();
    GetAllCategories();
  }, []);
  const GetAllCategories = async () => {
    try {
      const response = await getCategories();
      setCategoryData(response);
    } catch (err) {
    Swal.fire({ icon: "error", title: "Error", html: err?.response?.data?.html || err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };

  // const OnHandleChange = (e) => {
  //   const { name, value, type, files } = e.target;
  //   if (type === "file") {
  //     const avatarFile = files[0];
  //     const url = URL.createObjectURL(avatarFile);
  //     setPreviewImageUrl(url);
  //     setFormData((prev) => ({
  //       ...prev,
  //       [name]: avatarFile,
  //     }));
  //   } else {
  //     setFormData((prevProfile) => ({
  //       ...prevProfile,
  //       [name]: value,
  //     }));
  //   }
  // };

  // const addField = (e) => {
  //   e.preventDefault();
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     attributes: { ...prevFormData.attributes, "": "" },
  //   }));
  // };

  // const removeField = (key, e) => {
  //   e.preventDefault();
  //   const updatedAttributes = { ...formData.attributes };
  //   delete updatedAttributes[key];
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     attributes: updatedAttributes,
  //   }));
  // };

  // const handleAttributeChange = (key, event) => {
  //   const { name, value } = event.target;
  //   const updatedAttributes = { ...formData.attributes };

  //   if (name === "key") {
  //     const newKey = value;
  //     updatedAttributes[newKey] = updatedAttributes[key];
  //     delete updatedAttributes[key];
  //   } else {
  //     updatedAttributes[key] = value;
  //   }

  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     attributes: updatedAttributes,
  //   }));
  // };

  const handleDesChange = (value) => {
    console.log(value);
    setFormData((prevFormData) => ({
      ...prevFormData,
      fullDesc: value,
    }));
  };

  const OnHandleChange = async (e) => {
    const { name, type, value } = e.target;
    if (type !== "file") {
      setFormData((prevProfile) => ({
        ...prevProfile,
        [name]: value,
        // attributes: attributes,
      }));
    }
  };

  // const UploadProducts = async () => {
  //   setLoad(true);
  //   try {
  //     if (
  //       formData.productTitle !== "" &&
  //       formData.category !== "" &&
  //       formData.fullDesc !== "" &&
  //       formData.brand !== "" &&
  //       formData.currency !== "" &&
  //       formData.promotionalPrice !== "" &&
  //       formData.regularPrice !== "" &&
  //       formData.images !== null
  //     ) {
  //       const {
  //         brand,
  //         category,
  //         fullDesc,
  //         currency,
  //         productTitle,
  //         promotionalPrice,
  //         regularPrice,
  //         images,
  //       } = formData;

  //       const response = await AdminCreateProducts(
  //         currentUser.data.info.id,
  //         formData
  //       );

  //       setLoad(false);

  //       Swal.fire({
  //         title: "Product Created Successfully",
  //         icon: "success",
  //       }).then(() => {
  //         window.location.reload();
  //       });
  //     } else {
  //       Swal.fire({
  //         title: "All field is required",
  //         icon: "warning",
  //       });
  //       setLoad(false);
  //     }
  //   } catch (err) {
  //     setLoad(false);
  //     return err;
  //   }
  // };

  const UploadProducts = async () => {
    setFormData((prevData) => ({
      ...prevData,
      // attributes: attributes,
    }));
    console.log(formData);
    setLoad(true);
    try {
      if (
        formData.productTitle !== "" &&
        formData.category !== "" &&
        formData.subcategory !== "" &&
        formData.fullDesc !== "" &&
        formData.brand !== "" &&
        formData.currency !== "" &&
        formData.promotionalPrice !== "" &&
        formData.regularPrice !== "" &&
        formData.images !== null
      ) {
        const payload = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
          if (key !== "images" && value !== null && value !== "") {
            payload.append(key, value);
          }
        });
        payload.append("images", formData.images, "product-image.png");

        const response = await AdminCreateProducts(
          currentUser.data.info.id,
          payload
        );
        setLoad(false);

        Swal.fire({
          title: "Product Created Successfully",
          icon: "success",
          timer: 20000,
        }).then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire({
          title: "All fields are required",
          icon: "warning",
        });
        setLoad(false);
      }
    } catch (err) {
    setLoad(false);
    Swal.fire({ icon: "error", title: "Error", html: err?.response?.data?.html || err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };
  // const onCategoryChange = (e) => {
  // 	const { value } = e.target;
  //
  //       let data = categoryData.brands.filter((item, i) => item.subCategoryId === parseInt(value));
  // 	setBrands(data[0].brandName.split(","));
  // }
  const onSubCategoryChange = (e) => {
    const { name, value } = e.target;
    let data = categoryData.brands.filter(
      (item, i) => item.subCategoryId === parseInt(value)
    );
    setBrands(data[0]?.brandName?.split(",") || []);
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onCategoryChange = (e) => {
    setSubCategories([]);
    const { name, value } = e.target;
    let data = categoryData.subCategories.filter(
      (item, i) => item.categoryId === parseInt(value)
    );
    setSubCategories(data);
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <section class="content-main">
      <div class="row">
        <div class="col-11">
          <div class="content-header">
            <h2 class="content-title">Add New Product</h2>
            <div>
              {/* <button class="btn btn-light rounded font-sm mr-5 text-body hover-up">
                Save to draft
              </button> */}
              {load ? (
                <button disabled class="btn btn-md rounded font-sm hover-up">
                  Loading...
                </button>
              ) : (
                <button
                  onClick={UploadProducts}
                  className="btn btn-md rounded font-sm hover-up"
                >
                  Publish
                </button>
              )}
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="card mb-4">
            <div class="card-header">
              <h4>Basic</h4>
            </div>
            <div class="card-body">
              <form>
                <div class="mb-4">
                  <label for="product_name" class="form-label">
                    Product title<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    name="productTitle"
                    onChange={OnHandleChange}
                    type="text"
                    placeholder="Type here"
                    class="form-control"
                    id="product_name"
                  />
                </div>
                <div class="mb-4">
                  <label for="product_label" class="form-label">
                    Label
                  </label>
                  <input
                    name="label"
                    onChange={OnHandleChange}
                    type="text"
                    placeholder="Eg. Discount, Black Friday, Trending, Hot deals..."
                    class="form-control"
                    id="product_label"
                  />
                </div>
                {/*<div className="row d-flex align-items-center justify-content-between">
                  Array(desCount)
                    .fill()
                    .map(() => {
                      return (
                        <>
                          <div class="col-lg-4">
                            <div class="mb-4">
                              <label class="form-label">
                                Key
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <div class="row gx-2">
                                <input
                                  name="key"
                                  onChange={(e) => handleChangeDebounced(e)}
                                  // placeholder="Key"
                                  type="text"
                                  class="form-control"
                                />
                              </div>
                            </div>
                          </div>
                          :
                          <div class="col-lg-4">
                            <div class="mb-4">
                              <label class="form-label">
                                Description
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                name="description"
                                onChange={(e) => handleChangeDebounced(e)}
                                // placeholder="Description"
                                type="text"
                                class="form-control"
                              />
                            </div>
                          </div>
                        </>
                      );
                    }) 

                  {Object.keys(formData.attributes).length > 0 ? (
                    Object.keys(formData.attributes).map((key, index) => (
                      <div className="row align-items-center" key={index}>
                        <div className="col-lg-4">
                          <div className="mb-4">
                            <label className="form-label">
                              Key<span style={{ color: "red" }}>*</span>
                            </label>
                            <div className="row gx-2">
                              <input
                                name="key"
                                value={key}
                                onChange={(e) => handleAttributeChange(key, e)}
                                type="text"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <div className="mb-4">
                            <label className="form-label">
                              Description
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              name="description"
                              value={formData.attributes[key]}
                              onChange={(e) => handleAttributeChange(key, e)}
                              type="text"
                              className="form-control"
                            />
                          </div>
                        </div>
                        <button
                          className="col-lg-3 btn btn-md rounded font-sm hover-up"
                          onClick={(e) => removeField(key, e)}
                        >
                          Remove
                        </button>
                      </div>
                    ))
                  ) : (
                    <p className="text-center">No Attributes</p>
                  )}

                  <button
                    className="col-lg-3 btn btn-md btn-w-auto rounded font-sm hover-up"
                    onClick={(e) => addField(e)}
                  >
                    Add +
                  </button>
                </div> */}

                <div class="mb-4 mt-4 h-200">
                  <label class="form-label">
                    Full description<span style={{ color: "red" }}>*</span>
                  </label>
                  {/* <textarea
                    name="fullDesc"
                    onChange={OnHandleChange}
                    placeholder="Type here"
                    class="form-control"
                    rows="4"
                  ></textarea> */}
                  <div className="ql-container">
                    <ReactQuill
                      value={formData.fullDesc}
                      onChange={handleDesChange}
                      modules={modules}
                      formats={formats}
                      style={{ height: "320px", marginBottom: "50px" }}
                      theme="snow"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="mb-4 col-lg-4">
                      <label class="form-label">Quantity</label>
                      <div class="row gx-2">
                        <input
                          name="quantity"
                          onChange={OnHandleChange}
                          placeholder="0"
                          type="number"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="mb-4">
                      <label class="form-label">
                        Regular price<span style={{ color: "red" }}>*</span>
                      </label>
                      <div class="row gx-2">
                        <input
                          name="regularPrice"
                          onChange={OnHandleChange}
                          placeholder="₦"
                          type="number"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="mb-4">
                      <label class="form-label">
                        Promotional price<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        name="promotionalPrice"
                        onChange={OnHandleChange}
                        placeholder="₦"
                        type="number"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label">
                      Currency<span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      name="currency"
                      onChange={OnHandleChange}
                      class="form-select"
                    >
                      <option>--select--</option>
                      <option value="NGN">NGN</option>
                    </select>
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label">
                      Category<span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      id="category"
                      name="category"
                      onChange={onCategoryChange}
                      class="form-select"
                    >
                      <option>--select--</option>
                      {categoryData?.categories?.map((item, i) => (
                        <option key={"category" + i} value={item.ID}>
                          {item.categoryName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label">
                      Sub Category<span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      name="subcategory"
                      id="subcategory"
                      onChange={onSubCategoryChange}
                      class="form-select"
                    >
                      <option>--select--</option>
                      {subcategories?.map((item, i) => (
                        <option key={"subcategory" + i} value={item.ID}>
                          {item.subCategoryName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label">
                      Brand<span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      name="brand"
                      onChange={OnHandleChange}
                      class="form-select"
                    >
                      <option>--select--</option>
                      {brands?.map((name, i) => (
                        <option key={"brand" + i} value={name}>
                          {name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {/* <div class="mb-4">
                              <label class="form-label">Tax rate</label>
                              <input type="text" placeholder="%" class="form-control" id="product_name" />
                          </div> */}
                {/* <label class="form-check mb-4">
                              <input class="form-check-input" type="checkbox" value="" />
                              <span class="form-check-label"> Make a template </span>
                          </label> */}
              </form>
            </div>
          </div>

          {/* <div class="card mb-4">
                  <div class="card-header">
                      <h4>Shipping</h4>
                  </div>
                  <div class="card-body">
                      <form>
                          <div class="row">
                              <div class="col-lg-6">
                                  <div class="mb-4">
                                      <label for="product_name" class="form-label">Width</label>
                                      <input
                                          type="text"
                                          placeholder="inch"
                                          class="form-control"
                                          id="product_name"
                                      />
                                  </div>
                              </div>
                              <div class="col-lg-6">
                                  <div class="mb-4">
                                      <label for="product_name" class="form-label">Height</label>
                                      <input
                                          type="text"
                                          placeholder="inch"
                                          class="form-control"
                                          id="product_name"
                                      />
                                  </div>
                              </div>
                          </div>
                          <div class="mb-4">
                              <label for="product_name" class="form-label">Weight</label>
                              <input type="text" placeholder="gam" class="form-control" id="product_name" />
                          </div>
                          <div class="mb-4">
                              <label for="product_name" class="form-label">Shipping fees</label>
                              <input type="text" placeholder="₦" class="form-control" id="product_name" />
                          </div>
                      </form>
                  </div>
              </div> */}
        </div>
        <div class="col-lg-5">
          <div class="card mb-4">
            <div class="card-header">
              <h4>Media</h4>
            </div>
            <div class="card-body">
              <div class="">
                {/* {previewImageUrl !== "" ? (
                  <img src={previewImageUrl} alt="" />
                ) : (
                  <img src="assets/imgs/theme/upload.svg" alt="" />
                )}
                <input
                  required
                  onChange={OnHandleChange}
                  name="images"
                  class="form-control"
                  type="file"
                />  */}
                <ImageCropper
                  onCropped={(blob) =>
                    setFormData((prev) => ({
                      ...prev,
                      images: blob,
                    }))
                  }
                />
              </div>
            </div>
          </div>

          {/* <div class="card mb-4">
                  <div class="card-header">
                      <h4>Organization</h4>
                  </div>
                  <div class="card-body">
                      <div class="row gx-2">
                          <div class="col-sm-6 mb-3">
                              <label class="form-label">Category</label>
                              <select class="form-select">
                                  <option>Automobiles</option>
                                  <option>Home items</option>
                                  <option>Electronics</option>
                                  <option>Smartphones</option>
                                  <option>Sport items</option>
                                  <option>Baby and Tous</option>
                              </select>
                          </div>
                          <div class="col-sm-6 mb-3">
                              <label class="form-label">Sub-category</label>
                              <select class="form-select">
                                  <option>Nissan</option>
                                  <option>Honda</option>
                                  <option>Mercedes</option>
                                  <option>Chevrolet</option>
                              </select>
                          </div>
                          <div class="mb-4">
                              <label for="product_name" class="form-label">Tags</label>
                              <input type="text" class="form-control" />
                          </div>
                      </div>
                 
                  </div>
              </div> */}

          {/* <div class="card mb-4">
                  <div class="card-header">
                      <h4>Sales</h4>
                  </div>
                  <div class="card-body">
                      <div class="row gx-2">
                          <div class="mb-3">
                              <label class="form-label">Mark product as</label>
                              <select class="form-select">
                                  <option>Sale</option>
                                  <option>Best</option>
                                  <option>Hot</option>
                              </select>
                          </div>
                          <div class="mb-4">
                              <label class="form-label">Percentage off</label>
                              <input type="text" class="form-control" />
                          </div>
                      </div>
                
                  </div>
              </div> */}
        </div>
      </div>
    </section>
  );
};

export default AddProducts;
